// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--PlainTextToolTip-module--plainTextToolTip--kD6EdistaJClfE60g6Hq {
  width: 200px;
  white-space: wrap !important;
  max-width: 500px;
  font-size: 14px;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltips/PlainTextToolTip/PlainTextToolTip.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ","sourcesContent":[".plainTextToolTip {\n    width: 200px;\n    white-space: wrap !important;\n    max-width: 500px;\n    font-size: 14px;\n    line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plainTextToolTip": `zappyride_incentive_web--PlainTextToolTip-module--plainTextToolTip--kD6EdistaJClfE60g6Hq`
};
export default ___CSS_LOADER_EXPORT___;
